/* src/app/user-setting/presenters/user-setting.component.scss */
:host {
  height: 95vh;
}
:host .scroll-container {
  overflow: auto;
  max-height: 75vh;
  height: 75vh;
}
:host ::ng-deep table.p-datatable-table tbody.p-datatable-tbody > tr > td.medium-cell {
  align-self: center;
}
:host ::ng-deep table.p-datatable-table tbody.p-datatable-tbody > tr > td.large-cell {
  align-self: center;
}
:host ::ng-deep .sticky-table-container .p-datatable .p-datatable-tbody > tr.p-selectable-row > td.p-datatable-cell {
  height: 3em !important;
}
:host ::ng-deep .p-inputtext {
  height: 2.5em !important;
  padding: 0 0.5rem 0 0.5rem !important;
}
:host ::ng-deep .p-dropdown-label {
  margin-top: 0.2em;
}
:host ::ng-deep .p-dropdown.p-component {
  height: 2.5em !important;
  margin-top: 0.15em !important;
}
:host ::ng-deep .p-editable-column .p-inputtext.p-component {
  width: 100%;
  margin-top: 0.15em !important;
}
:host ::ng-deep .p-checkbox {
  margin-top: 0.45em !important;
}
:host ::ng-deep .sticky-table-container {
  max-height: 100%;
  overflow: auto;
  width: 100%;
  padding: 0;
}
:host ::ng-deep i {
  width: 1rem;
  height: 1rem;
  font-size: 1rem !important;
}
:host ::ng-deep .p-datatable > .p-datatable-thead > tr > th {
  vertical-align: top;
  position: sticky;
  top: 0;
  z-index: 10;
  padding-top: 0.5rem !important;
}
:host ::ng-deep .p-datatable .p-datatable-tbody > tr > td {
  padding-left: 1.5rem;
}
:host ::ng-deep .p-datatable .p-datatable-tbody > tr > td.p-editing-cell input {
  padding: 0 1.55rem;
  margin: 0;
  width: 100%;
  height: 1.75rem;
  border-radius: 0;
}
:host ::ng-deep .p-datatable .p-datatable-tbody > tr > td.p-editing-cell .p-chkbox-box {
  margin-left: 0.25rem;
}
:host ::ng-deep .p-datatable .p-datatable-tbody > tr > td.p-editing-cell .p-dropdown {
  height: 1.75rem;
  width: 100%;
  border-radius: 0;
  background-color: #fff;
}
:host ::ng-deep .p-datatable .p-datatable-tbody > tr > td.p-editing-cell .p-dropdown .p-dropdown-label-container label.p-dropdown-label {
  margin-top: 0.25rem;
}
:host ::ng-deep .p-datatable .p-datatable-tbody > tr > td.p-editing-cell .p-calendar {
  width: 100%;
}
/*# sourceMappingURL=user-setting.component.css.map */
